import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { settingsUrl: String }

  connect() {
    this._settingsLoaded = false
    const params = new URLSearchParams(window.location.search)
    const tab = params.get("tab")
    if (tab) {
      const target = this.tabTargets.find(t => t.dataset.tab === tab)
      if (target) this.switch({ currentTarget: target })
    }
  }

  switch(event) {
    event.preventDefault()
    const name = event.currentTarget.dataset.tab
    if (!name) return

    this.tabTargets.forEach(t => t.classList.remove("bg-black", "text-white"))
    this.tabTargets.forEach(t => t.classList.add("text-[#959494]", "hover:text-black", "hover:bg-[#ebebeb]"))
    event.currentTarget.classList.remove("text-[#959494]", "hover:text-black", "hover:bg-[#ebebeb]")
    event.currentTarget.classList.add("bg-black", "text-white")

    this.panelTargets.forEach(p => p.classList.add("hidden"))

    const panel = this.panelTargets.find(p => p.id === `tab-${name}`)
    if (panel) {
      panel.classList.remove("hidden")
      if (name === "settings" && !this._settingsLoaded) {
        this._settingsLoaded = true
        const frame = panel.querySelector("turbo-frame")
        if (frame) frame.src = this.settingsUrlValue
      }
    }
  }
}
